import React from "react";
import { useSelector } from "react-redux";

const ProgressLoader = () => {
    const { privacyPolicyLoading } = useSelector((state) => state.onLoadData);
    const { joinMeetingLoading } = useSelector((state) => state.joinMeeting);
    const { putSurveyRatingLoading, putSurveyCommentLoading } = useSelector((state) => state.survey);
    return (
        <>
            {(privacyPolicyLoading || joinMeetingLoading || putSurveyRatingLoading || putSurveyCommentLoading) && (
                <>
                    <div className='call-progress-loader'>
                        <div className='call-progress-line'></div>
                    </div>
                    <div className='call-progress-overlay'></div>
                </>
            )}
        </>
    );
};

export default ProgressLoader;
